<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.back()"/>
              {{ $t('health.nutritionalPlan.templates') }}
            </h1>
            <div class="header-add-button">
                  <span
                    v-tooltip.left.top-start="$t('health.nutritionalPlan.addTemplate')"
                    @click="createTemplate"
                  >
                    <font-awesome-icon
                      class="header-add-button-icon"
                      :icon="icon.add"/>
                  </span>
            </div>
          </div>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="planTable"
              :data="fetchData"
              :show-caption="false"
              class="datatable"
              :show-filter="true">
              <table-column show="id" label="Id" :hidden="true"></table-column>
              <table-column
                show="name"
                :label="$t('health.nutritionalPlan.name')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="typeText"
                :label="$t('health.nutritionalPlan.type')"
                header-class="text-left"
                cell-class="table-component__danger">
              </table-column>
              <table-column
                show="carbsFactor"
                :label="$t('health.nutritionalPlan.carbsFactor')"
                header-class="text-left"
                cell-class="table-component__danger">
              </table-column>

              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    :id="row"
                    v-on:click="onUpdate(row)"
                    :icon="icon.pencil"
                    class="table-iconset-icon"/>
                </template>
              </table-column>

              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="onDelete(row)"
                    :icon="icon.trash"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>

    </div>

    <ok-cancel-modal
      v-if="showConfirmationDeleteModal"
      v-on:ok="onDeleteConfirm"
      v-on:cancel="onDeleteCancel"
      :title="deleteModalMessage"
      :message="deleteModalMessage"
      :okButton="$t('commons.delete')"
      :cancelButton="$t('commons.cancel')">
      <div slot="body">
        <ul>
          <li>
            {{ planToDelete.name }}
          </li>
        </ul>
      </div>
    </ok-cancel-modal>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts//MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import Checkbox from '@/components/shared/forms/Checkbox';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';
import {faPlusCircle, faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons';
import {faPencilAlt, faTrashAlt} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import api from 'BRAND/api/nutritionPlan';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import Alert from '@/components/shared/alert/Alert';
import pagination from '@/components/shared/table/pagination';

export default {
  name: 'IngestTemplates',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron,
    HealthExplorerControlsUserSelect,
    TableColumn,
    TableComponent,
    TableRow,
    FontAwesomeIcon,
    Checkbox,
    OkCancelModal,
    Alert
  },

  data () {
    return {
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      showConfirmationDeleteModal: false,
      planToDelete: undefined,
      deleteModalMessage: '',
      disableUserSelect: false,
      noWeight: true,
      weight: null,
      selectedUser: null,
      plans: [],
      icon: {
        add: faPlusCircle,
        trash: faTrashAlt,
        pencil: faPencilAlt,
        warning: faExclamationTriangle
      },
      mealTypes: [
        'Desayuno',
        'Almuerzo',
        'Comida',
        'Merienda',
        'Cena'
      ],
      tablePageSize: 15,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  watch: {
    value: {
      handler: function (value) {
        this.variable = value;
      }
    },
    selectedUser: {
      handler: function () {
        this.requestData();
      }
    },
    getPlans: {
      handler: function () {
        this.$refs.planTable.refresh();
      }
    }
  },
  mounted () {
    this.requestData();
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.workspace'),
          link: '/workspace'
        },
        {
          name: this.$t('health.nutritionalPlan.menu'),
          link: '/nutritionalPlan/menu'
        },
        {
          name: this.$t('health.nutritionalPlan.templates'),
          link: '/ingest/templates',
          disabled: true
        }
      ];
    },
    getPlans () {
      return this.plans;
    }
  },
  methods: {
    requestData () {
      api.getTemplates(this).then(data => {
        this.plans = data;
        this.plans.forEach(value => {
          const typeIndex = this.mealTypes.findIndex((e) => e === value.type);
          value.typeText = this.$t('health.nutritionalPlan.mealTypes')[typeIndex];
        });
      });
    },
    fetchData ({page, filter, sort}) {
      page = page === null || isNaN(page) ? 1 : page;
      const tablePage = pagination.createPage(
        this.getPlans,
        this.tableState,
        ['name'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.requestData();
      }
    },
    onDelete (plan) {
      this.planToDelete = plan;
      this.deleteModalMessage = this.$t('health.nutritionalPlan.delete');
      this.showConfirmationDeleteModal = true;
    },
    onUpdate (plan) {
      this.$router.push({name: 'Template', params: {mode: 'edit', plan: plan}});
    },
    onDeleteConfirm () {
      const id = this.planToDelete.id;
      const planName = this.planToDelete.name;
      this.planToDelete = {};
      this.showConfirmationDeleteModal = false;
      api.deletePlan(this, id).then(() => {
        showAlert(this, this.$t('health.nutritionalPlan.successTemplateDelete', {name: planName}), 'success');
        this.plans = this.plans.filter(value => value.id !== id);
      }, () => {
        showAlert(this, this.$t('health.nutritionalPlan.errorTemplateDelete', {name: planName}), 'error');
      });
    },
    onDeleteCancel () {
      this.planToDelete = {};
      this.showConfirmationDeleteModal = false;
    },
    createTemplate () {
      this.$router.push({name: 'Template', params: {mode: 'create'}});
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}

.header-title {
  float: left;
}

.header-add-button {
  float: right;
}

.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}

.warning-icon {
  font-size: 1.5rem;
  color: $secondary;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/IngestTemplates.vue